import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { creditReviewDetailsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useDownloadCreditReviewReportMutation = (
	creditReviewId: string,
	token: string,
) => {
	const dispatch = useDispatch();

	return useMutation(
		async () => {
			if (!token) return Promise.reject("Token is missing");
			return creditReviewDetailsService.downloadCreditReviewReport(
				creditReviewId,
				token,
			);
		},
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useDownloadCreditReviewReportMutation;
